import { disasm as m } from '@moonbase-machines/mos6502';
export const { OPS, SIZE, disassemble, hex, operand } = m;